import { Extension } from '@tiptap/core'

import { linkInfoDisplayBoxPlugin } from '~/admin/components/prosemirror/plugins/link_info_display_box'
import { getBuilderResourcesForLinkPicker } from '../utilities'

export const LinkInfoBox = Extension.create({
  addOptions() {
    return { onEdit: null, labels: null }
  },

  addProseMirrorPlugins() {
    return [
      linkInfoDisplayBoxPlugin(getBuilderResourcesForLinkPicker, {
        onEdit: this.options.onEdit,
        labels: this.options.labels,
      }),
    ]
  },
})
